import { FilmSlate, Star, VideoCamera, MicrophoneStage, Crown, Sparkle } from "@phosphor-icons/react";

const FACES = [
  { icon: Star, grad: "linear-gradient(135deg, #1a1400, #3a2c00)" },
  { icon: FilmSlate, grad: "linear-gradient(135deg, #2a0033, #0a0012)" },
  { icon: VideoCamera, grad: "linear-gradient(135deg, #001d2b, #00323f)" },
  { icon: MicrophoneStage, grad: "linear-gradient(135deg, #2a0010, #120008)" },
  { icon: Crown, grad: "linear-gradient(135deg, #332400, #1a1200)" },
  { icon: Sparkle, grad: "linear-gradient(135deg, #0a0a0a, #1c1c1c)" },
];

// Revolving Hollywood-entertainment 3D cube for public pages
export function HollywoodCube({ size = 112 }) {
  const t = size / 2;
  const transforms = [
    `rotateY(0deg) translateZ(${t}px)`,
    `rotateY(90deg) translateZ(${t}px)`,
    `rotateY(180deg) translateZ(${t}px)`,
    `rotateY(-90deg) translateZ(${t}px)`,
    `rotateX(90deg) translateZ(${t}px)`,
    `rotateX(-90deg) translateZ(${t}px)`,
  ];
  return (
    <div className="scene shrink-0" style={{ width: size, height: size }} data-testid="hollywood-cube" aria-hidden="true">
      <div className="cube">
        {FACES.map((f, i) => {
          const Icon = f.icon;
          return (
            <div key={i} className="cube__face" style={{ transform: transforms[i], background: f.grad }}>
              <Icon size={size * 0.42} weight="fill" style={{ color: "#E9AC0C", filter: "drop-shadow(0 0 10px rgba(233,172,12,0.6))" }} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
